import {Col, Row, Button} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import CardOrder from "../cards/cardOrder";
import LogoutButton from "../layout/logoutButton";
import {useLocation} from "react-router-dom";
import ApiService from "../../services/ApiService";
import DateTimeUtils from "../../services/DateTimeUtils";

const Order = () =>{

    const location = useLocation();
    const [orderData, setOrderData] = useState();
    const [transactionId, setTransactionId] = useState();

    useEffect(() => {
        let baketId = location.state?.basketId;

        ApiService.getBasketDetailById(baketId).then(basketDetail => {
            const transaction = basketDetail.transactions.find(trans => {
                return trans.status === "FULFILL";
            });
            setOrderData(basketDetail)
            setTransactionId(transaction)
        })
            .catch(error => console.log(error))

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handlePrintView = () => {
        window.print()
    }


        return (
            <>
                <Row>
                    <Col lg={6}>
                        <Row className={'d-print-none'}>
                            <Col>
                                <Back />
                            </Col>
                        </Row>
                        <Row className={'mt-5 mb-2'}>
                            <Col>
                                <h2 className={'fw-bold'}>{orderData && DateTimeUtils.formatCourseStartData(orderData.creationDate)}</h2>
                            </Col>
                        </Row>

                        <Row className={'mb-4'}>
                            {orderData && <Col xs={12}>

                                <CardOrder basketData={orderData}/>
                                {(transactionId && transactionId.id !== undefined)? "Transaction ID: " + transactionId.id : "" }
                                <div className={'d-flex justify-content-end d-print-none'}>
                                    <Button variant={'primary'} className={'px-5 fw-bold'} onClick={handlePrintView}>Stampa vista</Button>
                                </div>
                            </Col>}
                        </Row>
                    </Col>
                    <Col className={'d-print-none'}>
                        <div className={'w-100 mt-4 mt-lg-0 d-flex justify-content-end'}>
                            <LogoutButton />
                        </div>
                    </Col>
                </Row>


            </>

        );
}

export default Order;
